import produce from 'immer';
import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { combineReducers } from 'redux';
import { ApiKeyAction, ApiKeyActionType } from '../../actions/apiKeyActions';

interface WithSecret {
  secret?: string;
}

interface ApiKeysById {
  [apiKeyId: string]: RcInstanceDTO.AccessCredentials & WithSecret;
}

const byId = (state: ApiKeysById = {}, action: ApiKeyAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ApiKeyActionType.LIST_PERSONAL_API_KEYS:
        return {};
      case ApiKeyActionType.LIST_PERSONAL_API_KEYS_OK: {
        action.data.forEach((apiKey) => {
          draft[apiKey.id] = apiKey;
        });

        break;
      }
      case ApiKeyActionType.GET_PERSONAL_API_KEY_OK: {
        draft[action.id] = action.data;
        break;
      }
      case ApiKeyActionType.CREATE_PERSONAL_API_KEY_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      case ApiKeyActionType.EDIT_PERSONAL_API_KEY_OK: {
        draft[action.id] = action.data;
        break;
      }
      case ApiKeyActionType.DELETE_PERSONAL_API_KEY_OK: {
        delete draft[action.id];
        break;
      }
      default:
        return state;
    }
  });

const allIds = (state: string[] = [], action: ApiKeyAction) => {
  switch (action.type) {
    case ApiKeyActionType.LIST_PERSONAL_API_KEYS:
      return [];
    case ApiKeyActionType.LIST_PERSONAL_API_KEYS_OK:
      return action.data.map((apiKey) => apiKey.id);
    case ApiKeyActionType.CREATE_PERSONAL_API_KEY_OK:
      return [...state, action.data.id];
    case ApiKeyActionType.DELETE_PERSONAL_API_KEY_OK:
      return state.filter((id) => id !== action.id);
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  allIds,
});
